import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';
import { SELECT_UP } from '../actions/types';

/**
 * Fires when the User scrolls down or up.
 * • If in Live mode:
 *      when the User moves up or down the Channel guide without actually changing the channel.
 * • If in VOD mode:
 *      when the User moves up or down the VOD section.
 */
export const scrollVerticalBeacon = (action) => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.INTERACT,
  eventName: EVENT_NAMES.SCROLL_VERTICAL,
  label: action.type === SELECT_UP ? 'up' : 'down',
  value: action.payload.index,
});
